<div class="share__link-container w-[450px] h-[310px] max-h-[95vh]">
  <div class="share__link-header">
    <h5>Share {{ data.formName | truncateStrPipe : 25 }}</h5>
    <div class="web__close-icon">
      <button type="button" class="close" data-dismiss="modal" (click)="closeDialog()">
        <span class="material-icons icons-close-mobile">close</span>
      </button>
    </div>
  </div>
  <div class="copy__share-link">
    <div class="copy__share-link-box">
      @if (shareLink) {
        <div class="d-flex justify-content-around">
          <div class="share-link">{{ shareLink ? shareLink : '' }}</div>
          <p style="font-weight: 700; font-size: 16px; line-height: 45.5px; cursor: pointer" (click)="copyLink(shareLink)">COPY</p>
        </div>
      } @else {
        <div class="ph-item" style="padding: 0px !important; width: 99%; background-color: white; height: 100%; border: 0px">
          <div class="ph-col-12" style="padding: 12px 17px !important">
            <div class="ph-row">
              <div class="ph-col-12 big"></div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="d-flex share__link-pin">
    <div class="d-flex items-center">
      <mat-checkbox class="example-margin mb-4" [(ngModel)]="usePin" (change)="onCheckChange($event)"></mat-checkbox> &nbsp;&nbsp;
      <p>Require a PIN to access file</p>
    </div>
    @if (usePin && sharePin) {
      <div class="d-flex pin">
        <p>{{ sharePin ? sharePin : '' }}</p>
        &nbsp;
        <span class="material-icons material-icons-round menuitem-icon" style="cursor: pointer" (click)="openChangePinDialog(sharePin)">edit</span>
      </div>
    }
  </div>
  <div class="share__link-footer">
    <form [formGroup]="shareEamilForm">
      <div class="share__link-footer-content">
        <mat-form-field appearance="fill" class="form-design-ui">
          <mat-label class="automtic-form-desing-lable">Email address</mat-label>
          <input type="email" matInput formControlName="email" />
          @if (shareEamilForm.controls['email'].value == '') {
            <mat-error> Email address is required. </mat-error>
          }
          @if (shareEamilForm.controls['email'].errors && shareEamilForm.controls['email'].value !== '') {
            <mat-error>
              Incorrect email address.
            </mat-error>
          }
        </mat-form-field>
        <div class="share__link-btn">
          <button class="h-[46px]" (click)="sendShareLinkEmail()" [style.background-color]="shareEamilForm.valid ? '#25508E' : '#010b181f'">
            Send
          </button>
        </div>
      </div>
    </form>
    <p>An email will be sent to the person you have listed above</p>
  </div>
</div>

